var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "identify-properties-viewer", style: _vm.componentStyle },
    [
      _vm.title
        ? _c(
            "thead",
            {
              key: _vm.title,
              staticClass: "identify-properties-viewer-title",
              style: _vm.titleStyle,
            },
            [
              _c("tr", [
                _c("th", { attrs: { colSpan: "2" } }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "tbody",
        { staticClass: "identify-properties-viewer-body" },
        _vm._l(_vm.bodyItems, function (item) {
          return _c("tr", { key: item.key, style: _vm.listStyle }, [
            _c("td", [_vm._v(_vm._s(item.key))]),
            _vm._v(" "),
            _c(
              "td",
              [
                item.links
                  ? [
                      _vm._l(item.links, function (link) {
                        return [
                          link.type == "popup"
                            ? [
                                _c(
                                  "a",
                                  {
                                    key: `${link.keyBind}`,
                                    attrs: { href: link.href },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.$emit(
                                          "emitOpenPopup",
                                          $event.target.href,
                                          _vm.feature,
                                          link.params,
                                          link.tools
                                        )
                                        return false
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(link.text) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            : link.type == "link"
                            ? [
                                _c(
                                  "a",
                                  {
                                    key: `${link.keyBind}`,
                                    attrs: {
                                      href: link.href,
                                      target: link.target,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(link.text) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            : link.type == "event"
                            ? [
                                _c(
                                  "a",
                                  {
                                    key: `${link.keyBind}`,
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.$emit(
                                          "dispatchEvent",
                                          link.params,
                                          _vm.feature
                                        )
                                        return false
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(link.text) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                        ]
                      }),
                    ]
                  : [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.textVal(item.val)) },
                      }),
                    ],
              ],
              2
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }